import { SVGProps } from "react"

const EditIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={18}
        height={18}
        viewBox="0 0 18 18"
        fill="none"
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M18.002 3.337a.996.996 0 0 1-.292.705l-1.83 1.83-3.75-3.75 1.83-1.83a.996.996 0 0 1 1.41 0l2.34 2.34c.187.187.292.44.292.705ZM0 18.002v-3.75l11.06-11.06 3.75 3.75-11.06 11.06H0Z"
            clipRule="evenodd"
        />
    </svg>
)
export default EditIcon
